import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import VisIcon from '../../../images/submenu_open copy 6.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Teig extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleTeig = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    showTeig = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowTeig,
                teig: this.props.teig
            }
        })
    }

    render() {
        const { t } = this.props
        var teig = this.props.teig
        var title = `${t('teig')} (${teig.lagretBeregnetAreal})`
        var arealmerknader = teig.arealmerknader ? teig.arealmerknader.map(a => a.arealmerknad).join(', ') : '';
        if (teig.hovedteig) title += ' - Hovedteig'
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleTeig}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{title}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    <div className="right icon-image tooltip" onClick={this.showTeig}>
                        <img className="tool" src={VisIcon} />
                        <div className="tooltip-content">{t('vis.teig')}</div>
                    </div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{teig.kommunenavn} ({teig.kommuneId})</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('teigmedflerematrikkelenheter')}</div>
                            <div className="value">{teig.teigMedFlereMatrikkelenheter ? "Ja": "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('uregistrertjordsameie')}</div>
                            <div className="value">{teig.uregistrertJordsameie ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('tvist')}</div>
                            <div className="value">{teig.tvist ? "Ja": "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('eiereavklart')}</div>
                            <div className="value">{teig.avklartEiere ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('beregnetareal')}</div>
                            <div className="value">{teig.lagretBeregnetAreal} m<sup>2</sup></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('arealmerknader')}</div>
                            <div className="value">{arealmerknader}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Teig)